import type { ReactElement } from "react";
export interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function StepProgress({
  currentStep,
  totalSteps,
}: StepProgressProps): ReactElement {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber <= currentStep;
        const isCurrent = stepNumber === currentStep;

        if (isCurrent) {
          return (
            <div
              key={stepNumber}
              className="h-2 w-10 rounded-full bg-green-300"
            />
          );
        }

        return (
          <div
            key={stepNumber}
            className={`h-2 w-2 rounded-full ${
              isCompleted ? "bg-white" : "bg-purple-900"
            }`}
          />
        );
      })}
    </div>
  );
}
